import React, { useEffect } from 'react';
import './PolicyPage.scss';

export default (function ImprintPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="return-policy-section">
      <div className="container-fluid-policy">
        <div className="policy-head-title">
          <h1>Impressum</h1>
        </div>
        <div className="section-body">
          <h2>Verantwortlich für den Inhalt</h2>

          <p>
            GOBI Cashmere Europe GmbH <br></br>
            Genshagener Str. 27<br></br>
            Halle 4<br></br>
            14974 Ludwigsfelde<br></br>
            Deutschland<br></br>
            Tel: +49 (0) 33 7934 189 32<br></br>
            E-Mail: support-1@gobicashmere.com
          </p>
          <p>
            Geschäftsführer: Amarsaikhan Baatarsaikhan<br></br>
            Gericht erster Instanz Cottbus<br></br>
            Registernummer HRB 12839 CB<br></br>
            Umsatzsteuer-Identifikationsnummer gemäß §27a UStG<br></br>
            DE815655506
          </p>

          <h2>Rechtliche Hinweise</h2>
          <p>
            Die EU-Kommission bietet die Möglichkeit einer Online-Streitbeilegung über eine Online-Plattform, die von
            ihr betrieben wird.<br></br>
            Diese Plattform ist über den externen Link erreichbar. http://ec.europa.eu/consumers/odr/.<br></br>
            Wir sind nicht verpflichtet oder nicht bereit, an einer Streitbeilegungsverfahren vor einer
            Verbraucherschutzbehörde teilzunehmen.
          </p>
        </div>
      </div>
    </div>
  );
});
